import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {GoriSignatureTakePhoto} from '../../modules/gori-signature'

export default function GoriSignatureTakePhotoWrapper() {
  return (
    <PublicWrapper>
      <GoriSignatureTakePhoto />
    </PublicWrapper>
  )
}
